import { customError, getServiceMethodKey, GLServiceBase, ServiceRoute } from "@/commonui/services";
import { CommonLocale } from "@/locales/localeid";
import { RWUnitGroupsReponseModel, WordManagerModel, WordSpecVpcRespnseModel } from "@/models/word-manager-model";
import { HttpMethod, ServerExceptionCode } from "commonui";

class WordManagerServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcswordmanager" };
	saveUpdateWordUrl = "saveupdateword";

	errMsgs = (() => {
		const result = {};
		result[
			getServiceMethodKey(
				this,
				HttpMethod.Post,
				ServerExceptionCode.DulicateWordExeption,
				`${this.serviceRoute.prefix}/${this.saveUpdateWordUrl}`
			)
		] = CommonLocale.CommonHttpDuplicateWordException;

		return result;
	})();

	getWordsInfo(params?: any): Promise<WordManagerModel[]> {
		return this.request.get(this.url("getwordsinfo"), params);
	}

	deleteWord(wordId): Promise<boolean> {
		return this.delete("deleteword", { wordId: wordId });
	}

	saveUpdateWordSpec(params: any): Promise<number> {
		return this.request.post(this.url(this.saveUpdateWordUrl), params);
	}

	calculateWordCount(params?: any): Promise<boolean> {
		return this.request.get(this.url("calculatewordcount"), params);
	}

	getWordVpcInfo(wordSpecId: number, gsVersionId: string, lsVersionId: string): Promise<WordSpecVpcRespnseModel[]> {
		return this.request.get(this.url("wordvpcinfo"), { wordSpecId, gsVersionId, lsVersionId });
	}

	wordExistsInUnit(levelId: number, word: string, versionId: string): Promise<boolean> {
		return this.request.get(this.url("wordexistsinunit"), { levelId, word, versionId });
	}

	getRWUnitGroups(rwAssignedUnitId: number | undefined): Promise<RWUnitGroupsReponseModel[]>{
		return this.request.get(this.url("unitgroups"), {unitId: rwAssignedUnitId})
	}
}

export const WordManagerService = new WordManagerServiceClass();
